module.exports = __webpack_public_path__ + "img/hourglass-icon.3bc647d3.svg";